import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocResponsibleWorker = async ({ docId, respWorkerId }) => {
  return await request.put(
    `/Docs/responsible_worker/${docId}?respWorkerId=${respWorkerId}`,
    null,
    'При изменении ответственного у документа произошла ошибка',
    'Error'
  );
};

const useChangeDocResponsibleWorker = () => {
  const mutation = useMutation(changeDocResponsibleWorker, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocResponsibleWorker: mutation.isLoading,
    changeDocResponsibleWorker: mutation.mutateAsync,
  };
};

export default useChangeDocResponsibleWorker;
